export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14298.4c7bcd14.jpg";